export default {
  methods: {
    showSuccessToast(message) {
      this.showNotification('is-success', message, 'is-bottom');
    },
    showErrorToast(message) {
      this.showNotification('is-danger', message, 'is-bottom');
    },
    showNotification(type, message, position) {
      this.$buefy.toast.open({
        message: message,
        type: type,
        position: position
      });
    }
  }
};
